import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AlphaNumericDirective } from './directive/alpha-numeric.directive';
import { BusyIfDirective } from './directive/busy-if.directive';
import { ButtonBusyDirective } from './directive/button-busy.directive';
import { DecimalNumberDirective } from './directive/decimal-number.directive';
import { NotEmptyStringDirective } from './directive/not-empty-string.directive';
import { NumericNumberDirective } from './directive/numeric-number.directive';
import { PhoneNumberMaskDirective } from './directive/phone-number-mask-directive';
import { PhoneNumberDirective } from './directive/phone-number.directive';
import { CurrentTimeZonePipe } from './pipe/convert-to-local-datetime.pipe';
import { DecodeBase64Pipe } from './pipe/decode-base64.pipe';
import { EncodeBase64Pipe } from './pipe/encode-base64.pipe';
import { FilterPipe } from './pipe/filter.pipe';
import { NotAvailablePipe } from './pipe/not-available.pipe';
import { PhoneNumberFormatPipe } from './pipe/phone-number-format.pipe';
import { SafeUrlPipe } from './pipe/safe-url.pipe';
import { SortByPipe } from './pipe/sort-by.pipe';
import { TruncateTo25CharPipe } from './pipe/truncate-to-25-char.pipe';
import { ValueCheckPipe } from './pipe/value-check.pipe';

@NgModule({
  declarations: [
    BusyIfDirective,
    DecimalNumberDirective,
    NumericNumberDirective,
    PhoneNumberDirective,
    PhoneNumberMaskDirective,
    AlphaNumericDirective,
    ButtonBusyDirective,
    EncodeBase64Pipe,
    DecodeBase64Pipe,
    FilterPipe,
    ValueCheckPipe,
    SortByPipe,
    SafeUrlPipe,
    PhoneNumberFormatPipe,
    NotAvailablePipe,
    TruncateTo25CharPipe,
    NotEmptyStringDirective,
    CurrentTimeZonePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CommonModule,
    BusyIfDirective,
    DecimalNumberDirective,
    NumericNumberDirective,
    PhoneNumberDirective,
    PhoneNumberMaskDirective,
    AlphaNumericDirective,
    ButtonBusyDirective,
    EncodeBase64Pipe,
    DecodeBase64Pipe,
    FilterPipe,
    ValueCheckPipe,
    SortByPipe,
    SafeUrlPipe,
    PhoneNumberFormatPipe,
    NotAvailablePipe,
    TruncateTo25CharPipe,
    NotEmptyStringDirective,
    CurrentTimeZonePipe
  ],
  providers: [],
})
export class UtilsModule { }
